import React from 'react'
import { useTranslation } from 'react-i18next'
import Academy from './styles'
import Card from '../../components/Card'
import ufcLogo from '../../../assets/images/icons/ufc.png'

const Experience = () => {
  const { t } = useTranslation()
  return (
    <Card>
      <div>
        <Academy.Header>
          <h4>{t('Academy')}</h4>
          <h2>{t('Formation')}</h2>
        </Academy.Header>
        <Academy.Wrapper>
          <h3>{t('Eng Comp')}</h3>
          <h5>{t('Start College')} - {t('EndCollege')}</h5>
          <h4>{t('UFC')}</h4>
          <Academy.CollegeLogo src={ufcLogo} alt="Universidade Federal do Ceará"/>
        </Academy.Wrapper>
      </div>
  </Card>
  )
}

export default Experience
